import React from 'react';
import './RestaurantMap.less';
import {Map} from 'elements/map/Map';
import {GeolocationLink} from "elements/geolocation-link/GeolocationLink";

export const RestaurantMap = ({latitude, longitude, address, zip}) => {
	return <div className="restaurant-map">
		<div className="restaurant-map__map">
			<GeolocationLink
				latitude={latitude}
				longitude={longitude}
				address={address}
				zip={zip}
			>
				<Map
					latitude={latitude}
					longitude={longitude}
				/>
			</GeolocationLink>
		</div>
	</div>
}
